<section class="page-card">
  <div class="section-kicker">Campaign Hub</div>
  <h2 class="section-title">Welcome To The Codex</h2>
  <p class="empty-copy">
    This vault is where party rosters, story arcs, and world lore come together. Use the
    navigation above to browse universes, inspect sessions, and manage the people behind every
    adventure.
  </p>

  @if (auth.hasSelectedRole()) {
    <div class="button-row">
      @if (auth.hasRole(userRole.Admin)) {
        <a class="secondary-btn home-action" [routerLink]="['/users']">Manage Users</a>
      }

      @if (auth.hasRole(userRole.DungeonMaster)) {
        <!-- <a class="secondary-btn home-action" [routerLink]="['/universes']">Manage Universes</a> -->
        <a class="secondary-btn home-action" [routerLink]="['/sessions']">Run Sessions</a>
      }

      @if (auth.hasRole(userRole.Player)) {
        <a class="secondary-btn home-action" [routerLink]="['/characters']">View Your Characters</a>
        <a class="secondary-btn home-action" [routerLink]="['/sessions']">Join Sessions</a>
      }
    </div>
  } @else {
    <p class="empty-copy">
      <a class="login-link" [routerLink]="['/login']">Log in</a> to unlock role-based actions for the Codex. You will choose the role for this visit before entering.
    </p>
  }
</section>
